/**
 * Avatar / thumbnail / media-preview pixel sizes.
 *
 * Suggested roles:
 *  - xxs  (24px): presence dot, badge avatar
 *  - xs   (32px): inline mention chip
 *  - sm   (40px): conversation row in the inbox list
 *  - md   (48px): message bubble avatar, agent profile chip
 *  - lg   (64px): header profile, settings page avatar
 *  - xl   (96px): contact details panel, modal hero avatar
 *  - xxl  (128px): onboarding splash avatar, marketing avatar grid
 *  - xxxl (192px): full-screen profile preview, media gallery hero
 */
export const thumbnailSize = {
  xxs: 24,
  xs: 32,
  sm: 40,
  md: 48,
  lg: 64,
  xl: 96,
  xxl: 128,
  xxxl: 192
} as const;

export type ThumbnailSizeTier = keyof typeof thumbnailSize;
